import React, { HTMLProps, useEffect, useState } from "react"
import classNames from "classnames"
import { Icon } from "../icons/Icon"
import clsx from "clsx"

export interface ImageProps extends HTMLProps<HTMLImageElement> {
	/** Apply
	 *  [animate-pulse](https://tailwindcss.com/docs/animation#pulse)
	 *  while image is loading */
	animateWhileLoading?: boolean
}

export const Image: React.FC<ImageProps> = ({
	animateWhileLoading,
	onLoad,
	className,
	...imgProps
}) => {
	const [isLoading, setIsLoading] = useState(true)
	const src = imgProps.src

	useEffect(() => {
		setIsLoading(true)
	}, [src])

	const handleOnLoad = (evt: React.SyntheticEvent<HTMLImageElement, Event>) => {
		setIsLoading(false)
		onLoad && onLoad(evt)
	}

	const shouldAnimate = isLoading && animateWhileLoading
	return (
		<div
			className={classNames("", {
				"animate-pulse": shouldAnimate,
			})}
		>
			<div className={clsx(className, "flex justify-center")}>
				<Icon hidden={!shouldAnimate} name="photo" className="self-center" />
				<img
					{...imgProps}
					key={src}
					className={className}
					hidden={isLoading}
					onLoad={handleOnLoad}
					crossOrigin="anonymous"
				/>
			</div>
		</div>
	)
}
